export default __webpack_public_path__ + "static/media/logo.19582e60.svg";